export const selectUserInfo = (state) => state.userInfo;
export const selectSalesmanInfo = (state) => state.salesman;
